var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingUnsure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "thmbNeutral",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 54.1",
    style: {
      enableBackground: "new 0 0 100 54.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "col-stroke_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "col-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.4,24.9c-1.7-4.6-6-5.3-10.1-5.9C84,18.1,76.8,17,68.9,8.3C64,3,57.4,0,50.7,0H16.2C7.3,0,0,7.3,0,16.2 v16.9c0,2.9,1.2,5.6,3.3,7.6c2,1.9,4.5,2.9,7.2,2.9c0.2,0,0.4,0,0.6,0c1.7-0.1,3.3-0.6,4.6-1.4c1.7,3.4,5.2,5.7,9.3,5.7 c1.8,0,3.5-0.5,5-1.3c1.7,3.8,5.5,6.5,9.9,6.5c2.8,0,5.4-1.1,7.3-2.9c2.1,2.4,5.2,4,8.7,4c6.4,0,11.6-5.2,11.6-11.6v-6 c4.7,2.6,9.2,3.8,14.5,3.8c5.7,0,13.2-2.4,16.4-7C100.1,30.7,100.5,27.8,99.4,24.9z M93.1,29.6c-1.8,2.6-7.2,4.3-11.1,4.3 c-5.4,0-9.5-1.4-14.5-4.9v-0.9c0-1.8-1.4-3.2-3.2-3.2c-1.8,0-3.2,1.4-3.2,3.2v14.5c0,2.9-2.3,5.2-5.2,5.2s-5.2-2.3-5.2-5.2v-0.4 v-7.3v-5.8c0-1.8-1.4-3.2-3.2-3.2s-3.2,1.4-3.2,3.2v5.8v7.3c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5v-4.8v-2.2V31 c0-1.8-1.4-3.2-3.2-3.2s-3.2,1.4-3.2,3.2v4.2v2.2c0,2.2-1.8,4-4,4s-4-1.8-4-4v-4.7v-1.1v-0.8c0-1.8-1.4-3.2-3.2-3.2 s-3.2,1.4-3.2,3.2v0.8v1.1c0,2.3-1.7,4.3-3.8,4.4c-1.1,0.1-2.2-0.3-3-1.1s-1.3-1.8-1.3-2.9V16.2c0-5.4,4.4-9.8,9.8-9.8h34.5 c4.9,0,9.8,2.2,13.3,6.1c9.4,10.3,18.3,11.8,24.1,12.7c3.7,0.6,4.8,0.9,5.2,1.8C93.7,28.1,93.6,28.8,93.1,29.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingUnsure);
export default __webpack_public_path__ + "static/media/rating-unsure.693c6744.svg";
export { ForwardRef as ReactComponent };